import React from 'react';
import { StarIcon } from 'lucide-react';
import { heroTestimonials } from '../../data/content';
import { Stars } from '../ui/Stars';
const RATING = 4.9;
const metrics = [{
  value: '500+',
  label: 'Clientes'
}, {
  value: '4.9',
  label: 'Calificación'
}, {
  value: '100%',
  label: 'Satisfacción'
}];
function RatingStars() {
  return <div className="relative inline-flex" role="img" aria-label={`Calificación promedio ${RATING} de 5 estrellas`} data-id="element-125" data-mp="2f4jxehzfymn8">
      <div className="flex items-center gap-1" data-id="element-126" data-mp="1mgfqxu91q5jh">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="h-4 w-4 text-ink-border" aria-hidden="true" data-id="element-127" data-mp="1rfim8mz84xe9" data-mpi={i} />)}
      </div>
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{
      width: `${RATING / 5 * 100}%`
    }} aria-hidden="true" data-id="element-128" data-mp="1wec04gifaqey">
        <div className="flex items-center gap-1" data-id="element-129" data-mp="32ue4sk0zrj03">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-4 w-4 shrink-0 fill-brand-gold text-brand-gold" data-id="element-130" data-mp="37vv5ofjh75go" data-mpi={i} />)}
        </div>
      </div>
    </div>;
}
export function HeroTestimonials() {
  return <section aria-labelledby="opiniones-title" className="w-full bg-ink-850" data-id="element-131" data-mp="2ygfjnf66lkru">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-132" data-mp="2ucpy6ykszjb1">
        <div className="rounded-2xl border border-ink-border bg-ink-card px-6 py-7 shadow-panel" data-id="element-133" data-mp="2pfha6hcz4l1v">
          <h2 id="opiniones-title" className="sr-only" data-id="element-134" data-mp="2kgegtu6cw39q">
            Opiniones de padres y madres que ya usan el método
          </h2>
          <dl className="grid grid-cols-1 divide-y divide-ink-border sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-135" data-mp="2focz3sqf5kcb">
            {metrics.map(metric => <div key={metric.label} className="flex flex-col items-center justify-center gap-1 px-4 py-4 text-center sm:py-0" data-id="element-136" data-mp="26oq4bps73cs8">
                <dd className="font-display text-3xl font-black text-brand-gold md:text-4xl" data-id="element-137" data-mp="21r7u7w2fyrin">
                  {metric.value}
                  {metric.label === 'Calificación' && <span className="font-sans text-lg font-bold text-subtle" data-id="element-138" data-mp="1n1d9iq2olwlt"> / 5</span>}
                </dd>
                <dt className="text-sm font-semibold text-body" data-id="element-139" data-mp="1d4ibs9e8g08l">{metric.label}</dt>
                {metric.label === 'Calificación' && <div className="mt-1" data-id="element-140" data-mp="1i4mqbtvkykw6">
                    <RatingStars data-id="element-141" data-mp="1i5eo9bcngupm" />
                  </div>}
              </div>)}
          </dl>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-142" data-mp="2assc8jydefxl">
          {heroTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-7 shadow-panel" data-id="element-143" data-mp="1w44m4t7amyf1">
              <Stars data-id="element-144" data-mp="2osa6heufqlec" />
              <blockquote className="mt-4 flex-1 text-base italic leading-relaxed text-body" data-id="element-145" data-mp="2orrzpoa5cos6">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-ink-border pt-4" data-id="element-146" data-mp="2tktgy2xtt0ex">
                <span className="block text-sm font-bold text-white" data-id="element-147" data-mp="i26vgieh11fr">{item.name}</span>
                <span className="block text-sm text-subtle" data-id="element-148" data-mp="d3vme9w02uyl">{item.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}